<template>
  <v-container fluid tag="section" :class="$isMobile ? 'pa-0 ' : 'pa-0'">
    <v-card class="my-0"  elevation='0'>
      <v-tabs v-model="tab" v-bind='$attrs'>
        <v-tab>客户详情</v-tab>
        <v-tab>联系人员</v-tab>
        <v-tab>跟进记录</v-tab>
        <v-tab>合同列表</v-tab>
        <v-tab>移交记录</v-tab>
        <v-tab>财务报表</v-tab>
        <v-tab>绑定微信</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <detail-view mini :item='item'></detail-view>
          <team-detail-view mini :contacts-person='item.contactsPersonList' :assist-person='item.assistPersonList'></team-detail-view>
        </v-tab-item>
        <v-tab-item>
          <contacts-detail-view mini :item='item.allContactsPersons'></contacts-detail-view>
        </v-tab-item>
        <v-tab-item>
          <follow-detail-view :item='item.followRecords'></follow-detail-view>
        </v-tab-item>
          <v-tab-item>
          <contracts-detail-view mini :item='item.contractInfos'></contracts-detail-view>
        </v-tab-item>
        <v-tab-item>
          <move-rerord-view :item='item.customerMoves'></move-rerord-view>
        </v-tab-item>
        <v-tab-item>
          <finance-detail-view :item='item.finances'></finance-detail-view>
        </v-tab-item>
          <v-tab-item>
          <wx-user-detail mini :item='item.wxUserInfoList'></wx-user-detail>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
  import WxUserDetail from '@/views/pages/pc/wechat/info/components/SimpleDetail.vue'
  import ContractsDetailView from '../components/Contracts.vue'
  import DetailView from '../components/Detail.vue'
  import ContactsDetailView from '../components/Contacts.vue'
  import TeamDetailView from '../components/Team.vue'
  import FollowDetailView from '../components/Follow.vue'
  import FinanceDetailView from '../components/Finance.vue'
  import MoveRerordView from '../components/Move.vue'

  export default {
    name: 'CustomerDetailIndex',
    components: {
      ContractsDetailView,
      DetailView,
      ContactsDetailView,
      TeamDetailView,
      FollowDetailView,
      FinanceDetailView,
      MoveRerordView,
      WxUserDetail
    },
    props: {
      item: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        tab: 0
      }
    }
  }
</script>

<style>
</style>
